var render = function render(){var _vm=this,_c=_vm._self._c;return _c('process-menu',{attrs:{"items":_vm.serviceProviders}})
}
var staticRenderFns = []

export { render, staticRenderFns }